import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import Image from '@jetshop/ui/Image';
import React from 'react';
import styled from 'react-emotion';
import MaxWidth from '../MaxWidth';
import { EztradStyling } from './EztradStyling';
import useShopId from '../../../utils/useShopId';

export const HeaderWrapper = styled(MaxWidth)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${({ theme }) => theme.below.xl} {
    max-width: 100%;
    width: 100%;
    padding: 0px;
  }
`;

export const NoImageWrapper = styled('div')`
  margin-top: 2.375rem;
  width: 100%;
  padding: 0 10px;

  ${({ theme }) => theme.below.md} {
    margin-top: 1.3125rem;
  }
`;

const Title = styled('h1')`
  font-weight: 700;
  line-height: 117%;
  font-size: 2.875rem;
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.green};
  font-feature-settings: 'liga' off;
  letter-spacing: 0.01em;

  ${({ theme }) => theme.below.md} {
    font-size: 2rem;
  }
`;

const Content = styled('div')`
  max-width: 600px;
  font-size: 0.875rem;
  line-height: 180%;
  text-align: center;
  margin-top: 1rem;
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-bottom: 0.875rem;

  li {
    color: ${({ theme }) => theme.colors.grey};
    font-weight: 500;
    font-size: 0.75rem;
    a {
      text-decoration: none;
      :hover {
        text-decoration: underline;
      }
    }
  }
`;

export const Inner = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .image-container {
    max-width: 600px;
    width: 100%;
    img {
      width: 100%;
    }
  }
`;

const PageHeader = ({ parents, breadcrumbText, content, title, images }) => {
  const breadcrumbProps = {
    breadcrumbText,
    parents
  };
  const isEztrad = useShopId() === 'eztrad';
  return (
    <HeaderWrapper className={isEztrad ? EztradStyling : ''}>
      <NoImageWrapper>
        <Content breadcrumbProps={breadcrumbProps} />
        <Inner className="page-header">
          {breadcrumbText && <StyledBreadcrumbs {...breadcrumbProps} />}
          {images && images.length > 0 ? (
            <div className="image-container">
              <Image
                sizes={[1, 1, 1, 1 / 2, 1 / 2]}
                src={images[4].url}
                alt={images[4].alt}
              />
            </div>
          ) : (
            <Title data-testid="page-header">{title}</Title>
          )}
          <Content
            data-testid="category-description"
            className="page-description"
          >
            <p>{content}</p>
          </Content>
        </Inner>
      </NoImageWrapper>
    </HeaderWrapper>
  );
};

export default PageHeader;
